import Sentry from "@similarweb/sentry-logger";

export const getCharsetEncoding = (file: File): Promise<string> => {
    return new Promise(async (resolve, reject) => {
        let jschardet;
        const defaultEncoding = "UTF-8";
        try {
            jschardet = await import("jschardet");
        } catch (e) {
            Sentry.error("Error importing jschardet package", e as Error);
            resolve(defaultEncoding);
        }
        if (jschardet) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const splitStringRegex = /\r|\n|\r\n/;
                const csvResult = (e.target!.result as string).split(splitStringRegex);
                const encoding = jschardet.detect ? jschardet.detect(csvResult.toString()).encoding : defaultEncoding;
                resolve(encoding);
            };
            reader.readAsBinaryString(file);
        } else {
            resolve(defaultEncoding);
        }
    });
};
